import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TWidgetPlan } from '@entities/widget-shop/model/types';
import { Checkbox, Flex, UiText } from '@shared/ui';

import cls from './PeriodPaymentItem.module.css';

interface IPeriodPaymentItemProps extends Partial<TWidgetPlan> {
    title: string;
    activePeriodPickedId: number;
    onPeriodPick: () => void;
}

export const PeriodPaymentItem = ({
    id,
    displayText,
    title,
    activePeriodPickedId,
    onPeriodPick,
}: IPeriodPaymentItemProps) => {
    const isCurrentlyActive = id === activePeriodPickedId;
    const { t } = useTranslation();
    return (
        <li
            className={cn(cls.periodItem, isCurrentlyActive && cls.isActive)}
            onClick={onPeriodPick}
        >
            <Flex direction="column" gap={8} align="start">
                <UiText tag="span" variant="boldPlain" weight="medium">
                    {displayText}
                </UiText>
                <Flex gap="4px" as="div" justify="start" align="center" wrap="wrap">
                    <UiText tag="span" variant="boldPlain" weight="medium">
                        {title}
                    </UiText>
                    <UiText tag="span" className={cls.byPeriod} variant="caption">
                        {t('WidgetShop.paymentModal.byPeriod')}
                    </UiText>
                </Flex>
            </Flex>
            <Checkbox
                isActive={isCurrentlyActive}
                checkBoxClassName={cn(cls.customCheckbox, !isCurrentlyActive && cls.hidden)}
                activeCheckedIconColor="currentColor"
            />
        </li>
    );
};
